import { I18nKey } from '@/i18n/types';
import { I18nParamKey } from '@/router/types';

/**
 * 验证 url 多语言是否正确
 */
export const checkI18nParamKey = (i18nParamKey: I18nParamKey | null): boolean => {
  if (i18nParamKey !== 'en-us' && i18nParamKey !== 'zh-tw' && i18nParamKey !== 'zh-cn') {
    return false;
  }

  return true;
};

/**
 * 将多语言转换成 url 多语言参数
 */
export const convertI18nKeyToI18nParamKey = (i18nKey: I18nKey | null): I18nParamKey => {
  switch (i18nKey) {
    case 'enUS':
      return 'en-us';
    case 'zhTW':
      return 'zh-tw';
    case 'zhCN':
      return 'zh-cn';
    default:
      console.error('i18nKey 匹配失败, 这是一个非常严重的错误, 请检查');
      return 'en-us';
  }
};
